

export const Endpoints = {
  applicationList: "loan/application/list/10/1",
  applicationInfo: "loan/application/info/",
  downloadDocuments: "download/application/documents/",
  downloadAllApplications: "download/application/documents/",
  uploadDocument: "upload/image",
  updateProductStatus: "loan/application/product/status/update",
  updateGuarantorStatus: "loan/application/guarantor/status/update",
  previewApplication: "preview/application",
  downloadFile: "download/file",
  makeAvailable: "remove/guarantor/rejection",
  downloadFlooringDocumnets: "flooring/application/downloadZipDocs/",
};

export const APIResult = {
  SUCCESS: true,
  FAILURE: false,
};

export const API = {
  BaseUrl: "https://api.ohhto.com/v1/agent/",
  serverUrl: "https://api.ohhto.com/v1/",
  webUrl:"https://loan.ohhto.com/",
  EndPoint: Endpoints,
  Result: APIResult,
};
export const serverUrl = "https://loan.ohhto.com/agent/";
export const IMAGE_BASE_URL = "https://api.ohhto.com/";

// export const API = {
//   BaseUrl: "http://localhost:8000/v1/agent/",
//   serverUrl: "http://localhost:8000/v1/",
//   EndPoint: Endpoints,
//   Result: APIResult
// }

// export const IMAGE_BASE_URL = "http://localhost:8000/v1/";
// export const serverUrl = "http://localhost:8000/v1/agent/";

export const dataURItoBlob = async (url) => {
  return await (await fetch(url)).blob();
};

export const FurnishOptions = [
  {
    label: "Family - Under Same Roof",
    value: "Family - Under Same Roof",
  },
  {
    label: "Family - Not Under Same Roof",
    value: "Family - Not Under Same Roof",
  },
  {
    label: "Family & Friends",
    value: "Family & Friends",
  },
];


export const CommomPermission = {
  create_permission: 1,
  delete_permission: 1,
  permission: 1,
  update_permission: 1,
  view_permission: 1
}
const CheckPermissions = (array, keyword, getState) => {
  if (getState) {
    return array?.filter((it) => it?.name === keyword).pop();
  } else {
    return array
      ?.filter((item) => item.name === `${keyword}`)
      ?.map((it) => it.view_permission == 1)
      ?.pop();
  }
};

export const HasPermission = (pathname, Permissions, getState) => {
  switch (pathname) {
    case "/loan-products":
      return CheckPermissions(Permissions, "loan-product", getState);
    case "/case-list":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/case-detail":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/case-detail-documents":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/case-detail-status":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/preview-aa":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/case-summary":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/guarantor-detail":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/view-aa":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/view-application":
      return CheckPermissions(Permissions, "loan-application", getState);
    case "/dealer-bonus":
      return CheckPermissions(Permissions, "dealer-bonus", getState);
    case "/aa-setup":
      return CheckPermissions(Permissions, "aa-setup", getState);
    case "/user-roles":
      return CheckPermissions(Permissions, "user-roles", getState);
    case "/user-accounts":
      return CheckPermissions(Permissions, "user-accounts", getState);
    case "/notification/application_updates":
      return CheckPermissions(Permissions, "application-updates", getState);
    case "/notification/flooring_updates":
      return CheckPermissions(Permissions, "flooring-updates", getState);

    default:
      return null;
  }
};

export const LtHtContent = (
  <div className="w-[200px] pt-[10px] pb-[5px]">
    <ul className="pl-[15px]">
      <li className="list-disc text-[12px]"> LT = Lowest Tier</li>
      <li className="list-disc text-[12px]"> HT = Higher Tier</li>
    </ul>
    <p className="my-[7px] text-[12px]">
      Most banks, finance and in-house loan providers have a 2 or more interest
      rate for their loan product. We have organise them under LT & HT for your
      ease of information when using our portal.
    </p>
  </div>
);

export const DownloadDocumentFile = async (url) => {
  fetch(IMAGE_BASE_URL + url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Failed to download: ${response.status} ${response.statusText}`
        );
      }
      return response.blob();
    })
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "document";
      a.click();
      URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Error downloading file:", error);
    });
  // const response = await ServerAPI.DownloadFile(url);
  // if (response) {
  //     console.log(response.data);
  // }
};

export const FormatFlooringVouchers = (arr) => {
  // this gives an object with dates as keys
  const groups = arr.reduce((groups, game) => {
    const date = game.temp_date;
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(game);
    return groups;
  }, {});

  // Edit: to add it in the array format instead
  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      vouchers: groups[date],
    };
  });
  return groupArrays;
};

export const FormatCurrency = (str) => {
  if (str !== undefined && str !== null && str !== "") {
    if (str.toString().includes(".")) {
      const temp = str.toString().includes(".")
        ? str.toString().slice(0, str.toString().indexOf("."))
        : str;
      const decimalPart = str.toString().includes(".")
        ? str.toString().slice(str.toString().indexOf(".") + 1, str?.length)
        : "";
      return temp !== undefined
        ? decimalPart === "00"
          ? temp
          : decimalPart?.length <= 2
            ? decimalPart?.length == 1 ? `${temp}.${decimalPart}0` : `${temp}.${decimalPart}`
            : `${temp}.${decimalPart.slice(0, 2)}`
        : "";
    } else {
      return str;
    }
  } else {
    return "";
  }
};
export const base64ToFile = (base64String, fileName) => {
  let arr = base64String.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
};

export const FlooringPdfBaseUrl =
  `${API.BaseUrl}flooring/application/AAF/`;
export const FlooringCaseSummaryUrl =
  `${API.BaseUrl}flooring/application/case-summary/`;
export const FlooringSOAUrl =
  `${API.BaseUrl}flooring/application/SOA/`;

export const FlooringCheckRedemption =
  `${API.BaseUrl}flooring/application/SOA-DRAFT/`;
